<!--
 * @Author: your name
 * @Date: 2021-07-22 16:54:40
 * @LastEditTime: 2021-07-23 15:36:59
 * @LastEditors: Please set LastEditors
 * @Description: 视频监控
 * @FilePath: \contingency-manage\src\views\map3D\crame\CramePage.vue
-->
<template>
  <div class="CramePage">
    <ul class="crameStatus">
      <template v-for="item in crameStatus" :key="item.type">
        <li class="crameStatusItem" @click="crameStatusClick(item)">
          <p :class="{ crameStatusItemHover: item.checked ? true : false }"></p>
          <div class="icon" :class="`icon` + item.type">
            <x-icon type="icon-shexiangji1" size="24px"></x-icon>
          </div>
          <div class="content">
            <span class="label">{{ item.name }}</span>
            <span class="value">{{ item.value }}</span>
          </div>
        </li>
      </template>
    </ul>
  </div>
</template>
<script >
import {
  defineComponent,
  reactive,
  toRefs,
  onBeforeUnmount,
  onMounted,
  inject,
  watchEffect,
  nextTick,
} from "vue";
export default defineComponent({
  name: "CramePage",
  components: {},
  props: {
    cameraList: {
      type: Array,
      default: () => [],
    },
    cameraPointRef: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const data = reactive({
      cameraListSure: [],
      crameStatus: [
        {
          checked: false,
          name: "摄像机数量",
          value: 0,
          list: [],
        },
        { checked: false, name: "正常设备", value: 0, type: 1, list: [] },
        { checked: false, name: "离线设备", value: 0, type: 2, list: [] },
        { checked: false, name: "故障设备", value: 0, type: 3, list: [] },
      ],
    });
    const setDeviceShowState = inject("setDeviceShowState", () => {});
    const refData = toRefs(data);
    watchEffect(() => {
      data.crameStatus.forEach((item) => {
        item.value = 0;
      });
      data.crameStatus[0].value = props.cameraList.length;
      nextTick(() => {
        props.cameraList.forEach((el, index) => {
          if (el.item.deviceLineStatus == "0") {
            data.crameStatus[1].value += 1;
            data.crameStatus[1].list.push(el);
          }
          if (el.item.deviceLineStatus == "1") {
            data.crameStatus[2].value += 1;
            data.crameStatus[2].list.push(el);
          }
          if (el.item.deviceLineStatus == "2") {
            data.crameStatus[3].value += 1;
            data.crameStatus[3].list.push(el);
          }
        });
      });
    });
    onMounted(() => {
      // 进入页面时隐藏设备点位
      setDeviceShowState(false);
    });
    onBeforeUnmount(() => {
      // 离开页面时显示设备点位
      setDeviceShowState(true);
    });
    const methods = {
      crameStatusClick(item) {
        if (item.type) {
          item.checked = !item.checked;
          emit("emitChangeVideoPoint", item);
        }
      },
    };
    return { ...refData, ...methods };
  },
});
</script>
<style  lang='scss' scoped >
.CramePage {
  position: absolute;
  display: flex;
  width: 100%;
  justify-content: center;
  top: 70px;
  z-index: 1;
  color: #fff;
  // position: relative;
  // background: red;
  // color: #fff;
  // z-index: 3;
  // translate: 50%, 50%;
  .crameStatus {
    // position: absolute;
    top: 15px;
    right: 15%;
    @include flex-row-e-c;

    .crameStatusItem {
      cursor: pointer;
      box-shadow: 0 0 10px 0 #0d6099 inset;
      border-radius: 20px 20px 0 20px;
      margin: 0 5px;
      background-color: rgba($color: #0a1f4c, $alpha: 0.7);
      padding: 15px;
      position: relative;
      @include flex-row-c-c;
      .crameStatusItemHover {
        width: 100%;
        height: 100%;
        border-radius: 20px 20px 0 20px;
        position: absolute;
        /* box-shadow: 0 0 10px 0 #555 inset !important; */
        background-color: rgba(85, 85, 85, 0.5) !important;
      }
      .icon {
        height: 50px;
        width: 50px;
        font-size: 20px;
        background-color: #729ef8;
        border-radius: 50%;
        margin-right: 10px;
        @include flex-row-c-c;
        &.icon1 {
          background-color: #72ddb2;
        }
        &.icon2 {
          background-color: #9a9ca3;
        }
        &.icon3 {
          background-color: #d94872;
        }
        &.icon4 {
          // background-color: #d94872;
        }
      }
      .content {
        @include flex-col-c-c;
        line-height: 26px;
        .value {
          font-size: 22px;
          color: #2acbd6;
        }
      }
    }
  }
}
</style>
